import { spxIconAasct } from './spxIcon-aasct.icon';
import { spxIconAddShoppingCart } from './spxIcon-add_shopping_cart.icon';
import { spxIconAlert02 } from './spxIcon-alert_02.icon';
import { spxIconAlertCircle } from './spxIcon-alert_circle.icon';
import { spxIconAlertFilled } from './spxIcon-alert_filled.icon';
import { spxIconAlertRounded } from './spxIcon-alert_rounded.icon';
import { spxIconAnalytics02Desktop } from './spxIcon-analytics_02_desktop.icon';
import { spxIconArrowDoubleUp01Sharp } from './spxIcon-arrow_double_up_01_sharp.icon';
import { spxIconArrowDown01Sharp } from './spxIcon-arrow_down_01_sharp.icon';
import { spxIconArrowLeft01Sharp } from './spxIcon-arrow_left_01_sharp.icon';
import { spxIconArrowLeft } from './spxIcon-arrow_left.icon';
import { spxIconArrowRight } from './spxIcon-arrow_right.icon';
import { spxIconArrowUp01Sharp } from './spxIcon-arrow_up_01_sharp.icon';
import { spxIconArrowUpDown } from './spxIcon-arrow_up_down.icon';
import { spxIconAuditAt } from './spxIcon-audit_at.icon';
import { spxIconAuditBy } from './spxIcon-audit_by.icon';
import { spxIconAuditLog } from './spxIcon-audit_log.icon';
import { spxIconBleeding } from './spxIcon-bleeding.icon';
import { spxIconCalendar02 } from './spxIcon-calendar_02.icon';
import { spxIconCalendarDates } from './spxIcon-calendar_dates.icon';
import { spxIconCancel01 } from './spxIcon-cancel_01.icon';
import { spxIconCancelOutlined } from './spxIcon-cancel_outlined.icon';
import { spxIconCancel } from './spxIcon-cancel.icon';
import { spxIconCellularActionRequired } from './spxIcon-cellular_action_required.icon';
import { spxIconCellularNoConnection } from './spxIcon-cellular_no_connection.icon';
import { spxIconCellularNotAvailable } from './spxIcon-cellular_not_available.icon';
import { spxIconCellularSignalHigh } from './spxIcon-cellular_signal_high.icon';
import { spxIconCellularSignalLow } from './spxIcon-cellular_signal_low.icon';
import { spxIconCellularSignalMedium } from './spxIcon-cellular_signal_medium.icon';
import { spxIconCellularSignalNoData } from './spxIcon-cellular_signal_no_data.icon';
import { spxIconChartHistogram } from './spxIcon-chart_histogram.icon';
import { spxIconChartBadge } from './spxIcon-chart-badge.icon';
import { spxIconCheckCircleOutline } from './spxIcon-check_circle_outline.icon';
import { spxIconCheckRing } from './spxIcon-check_ring.icon';
import { spxIconCheck } from './spxIcon-check.icon';
import { spxIconCheckmarkCircle02 } from './spxIcon-checkmark_circle_02.icon';
import { spxIconChevronLeft } from './spxIcon-chevron_left.icon';
import { spxIconChevronRight } from './spxIcon-chevron_right.icon';
import { spxIconClock01 } from './spxIcon-clock_01.icon';
import { spxIconClose } from './spxIcon-close.icon';
import { spxIconCloudArrow } from './spxIcon-cloud_arrow.icon';
import { spxIconCommentAdd02 } from './spxIcon-comment_add_02.icon';
import { spxIconCustomerService } from './spxIcon-customer-service.icon';
import { spxIconDashboardConfigurations } from './spxIcon-dashboard-configurations.icon';
import { spxIconDashboardDutyCycle } from './spxIcon-dashboard-duty-cycle.icon';
import { spxIconDeviceInProvisioning } from './spxIcon-device-in-provisioning.icon';
import { spxIconDifferentialPressure } from './spxIcon-differential-pressure.icon';
import { spxIconDisconnect } from './spxIcon-disconnect.icon';
import { spxIconDocumentSettings } from './spxIcon-document_settings.icon';
import { spxIconDropArrows } from './spxIcon-drop_arrows.icon';
import { spxIconDropOutlined } from './spxIcon-drop_outlined.icon';
import { spxIconDrop } from './spxIcon-drop.icon';
import { spxIconDrops } from './spxIcon-drops.icon';
import { spxIconDrySolidsContent } from './spxIcon-dry-solids-content.icon';
import { spxIconError } from './spxIcon-error.icon';
import { spxIconFileFilled } from './spxIcon-file_filled.icon';
import { spxIconFileFoldedFilled } from './spxIcon-file_folded_filled.icon';
import { spxIconFileFolded } from './spxIcon-file_folded.icon';
import { spxIconFileUnknown } from './spxIcon-file_unknown.icon';
import { spxIconFileSecurity } from './spxIcon-file-security.icon';
import { spxIconFile } from './spxIcon-file.icon';
import { spxIconFillLevel } from './spxIcon-fill-level.icon';
import { spxIconFilterOutlined } from './spxIcon-filter_outlined.icon';
import { spxIconFlow } from './spxIcon-flow.icon';
import { spxIconGearWrench } from './spxIcon-gear_wrench.icon';
import { spxIconHeartbeat } from './spxIcon-heartbeat.icon';
import { spxIconHourglassOff } from './spxIcon-hourglass_off.icon';
import { spxIconInfo } from './spxIcon-info.icon';
import { spxIconInformationCircle } from './spxIcon-information_circle.icon';
import { spxIconInstructions } from './spxIcon-instructions.icon';
import { spxIconKpi } from './spxIcon-kpi.icon';
import { spxIconLogout03 } from './spxIcon-logout_03.icon';
import { spxIconMailEnvelope } from './spxIcon-mail_envelope.icon';
import { spxIconMaintenance } from './spxIcon-maintenance.icon';
import { spxIconMenu } from './spxIcon-menu.icon';
import { spxIconModuleNotInstalled } from './spxIcon-module_not_installed.icon';
import { spxIconMoreHorizontal } from './spxIcon-more_horizontal.icon';
import { spxIconPencilEdit } from './spxIcon-pencil_edit.icon';
import { spxIconPlanCondition } from './spxIcon-plan-condition.icon';
import { spxIconPlanPredictive } from './spxIcon-plan-predictive.icon';
import { spxIconPlanPreventiveHours } from './spxIcon-plan-preventive-hours.icon';
import { spxIconPlusSignSquareDesktop } from './spxIcon-plus_sign_square_desktop.icon';
import { spxIconPlusSign } from './spxIcon-plus_sign.icon';
import { spxIconPower } from './spxIcon-power.icon';
import { spxIconPreventiveMaintenanceDesktop } from './spxIcon-preventive_maintenance_desktop.icon';
import { spxIconPump } from './spxIcon-pump.icon';
import { spxIconRefresh } from './spxIcon-refresh.icon';
import { spxIconRemoteMaintenance } from './spxIcon-remote-maintenance.icon';
import { spxIconRemoveCircle } from './spxIcon-remove_circle.icon';
import { spxIconScheduleClock } from './spxIcon-schedule_clock.icon';
import { spxIconSearchRemove } from './spxIcon-search_remove.icon';
import { spxIconSearch } from './spxIcon-search.icon';
import { spxIconSend } from './spxIcon-send.icon';
import { spxIconSignDocument } from './spxIcon-sign_document.icon';
import { spxIconSite } from './spxIcon-site.icon';
import { spxIconSort } from './spxIcon-sort.icon';
import { spxIconSquareArrowUpRightRound } from './spxIcon-square_arrow_up_right_round.icon';
import { spxIconSquareArrowUp } from './spxIcon-square_arrow_up.icon';
import { spxIconSquareLock02 } from './spxIcon-square_lock_02.icon';
import { spxIconStatusCanceled } from './spxIcon-status_canceled.icon';
import { spxIconStatusClosed } from './spxIcon-status_closed.icon';
import { spxIconStatusComplete } from './spxIcon-status_complete.icon';
import { spxIconStatusInProgress } from './spxIcon-status_in_progress.icon';
import { spxIconStatusNew } from './spxIcon-status_new.icon';
import { spxIconStatusPending } from './spxIcon-status_pending.icon';
import { spxIconStatusScheduled } from './spxIcon-status_scheduled.icon';
import { spxIconStorefront } from './spxIcon-storefront.icon';
import { spxIconTick01 } from './spxIcon-tick_01.icon';
import { spxIconTick } from './spxIcon-tick.icon';
import { spxIconUnavailable } from './spxIcon-unavailable.icon';
import { spxIconUnlink04 } from './spxIcon-unlink_04.icon';
import { spxIconUserCircle } from './spxIcon-user_circle.icon';
import { spxIconVisibilityOff } from './spxIcon-visibility_off.icon';
import { spxIconVisibility } from './spxIcon-visibility.icon';
import { spxIconWarning } from './spxIcon-warning.icon';
import { spxIconWifiActionRequired } from './spxIcon-wifi_action_required.icon';
import { spxIconWifiAttention } from './spxIcon-wifi_attention.icon';
import { spxIconWifiNoConnection } from './spxIcon-wifi_no_connection.icon';
import { spxIconWifiNoSignal } from './spxIcon-wifi_no_signal.icon';
import { spxIconWifiNotAvailable } from './spxIcon-wifi_not_available.icon';
import { spxIconWifiOff } from './spxIcon-wifi_off.icon';
import { spxIconWifiSignalHigh } from './spxIcon-wifi_signal_high.icon';
import { spxIconWifiSignalLow } from './spxIcon-wifi_signal_low.icon';
import { spxIconWifiSignalMedium } from './spxIcon-wifi_signal_medium.icon';
import { spxIconWifiSignalNoData } from './spxIcon-wifi_signal_no_data.icon';
import { spxIconWifi } from './spxIcon-wifi.icon';
import { spxIconWrenchFilled } from './spxIcon-wrench_filled.icon';
import { spxIconWrenchOutlined } from './spxIcon-wrench_outlined.icon';
import { spxIconWrench } from './spxIcon-wrench.icon';
export var completeIconSet = [
    spxIconAasct,
    spxIconAddShoppingCart,
    spxIconAlert02,
    spxIconAlertCircle,
    spxIconAlertFilled,
    spxIconAlertRounded,
    spxIconAnalytics02Desktop,
    spxIconArrowDoubleUp01Sharp,
    spxIconArrowDown01Sharp,
    spxIconArrowLeft01Sharp,
    spxIconArrowLeft,
    spxIconArrowRight,
    spxIconArrowUp01Sharp,
    spxIconArrowUpDown,
    spxIconAuditAt,
    spxIconAuditBy,
    spxIconAuditLog,
    spxIconBleeding,
    spxIconCalendar02,
    spxIconCalendarDates,
    spxIconCancel01,
    spxIconCancelOutlined,
    spxIconCancel,
    spxIconCellularActionRequired,
    spxIconCellularNoConnection,
    spxIconCellularNotAvailable,
    spxIconCellularSignalHigh,
    spxIconCellularSignalLow,
    spxIconCellularSignalMedium,
    spxIconCellularSignalNoData,
    spxIconChartHistogram,
    spxIconChartBadge,
    spxIconCheckCircleOutline,
    spxIconCheckRing,
    spxIconCheck,
    spxIconCheckmarkCircle02,
    spxIconChevronLeft,
    spxIconChevronRight,
    spxIconClock01,
    spxIconClose,
    spxIconCloudArrow,
    spxIconCommentAdd02,
    spxIconCustomerService,
    spxIconDashboardConfigurations,
    spxIconDashboardDutyCycle,
    spxIconDeviceInProvisioning,
    spxIconDifferentialPressure,
    spxIconDisconnect,
    spxIconDocumentSettings,
    spxIconDropArrows,
    spxIconDropOutlined,
    spxIconDrop,
    spxIconDrops,
    spxIconDrySolidsContent,
    spxIconError,
    spxIconFileFilled,
    spxIconFileFoldedFilled,
    spxIconFileFolded,
    spxIconFileUnknown,
    spxIconFileSecurity,
    spxIconFile,
    spxIconFillLevel,
    spxIconFilterOutlined,
    spxIconFlow,
    spxIconGearWrench,
    spxIconHeartbeat,
    spxIconHourglassOff,
    spxIconInfo,
    spxIconInformationCircle,
    spxIconInstructions,
    spxIconKpi,
    spxIconLogout03,
    spxIconMailEnvelope,
    spxIconMaintenance,
    spxIconMenu,
    spxIconModuleNotInstalled,
    spxIconMoreHorizontal,
    spxIconPencilEdit,
    spxIconPlanCondition,
    spxIconPlanPredictive,
    spxIconPlanPreventiveHours,
    spxIconPlusSignSquareDesktop,
    spxIconPlusSign,
    spxIconPower,
    spxIconPreventiveMaintenanceDesktop,
    spxIconPump,
    spxIconRefresh,
    spxIconRemoteMaintenance,
    spxIconRemoveCircle,
    spxIconScheduleClock,
    spxIconSearchRemove,
    spxIconSearch,
    spxIconSend,
    spxIconSignDocument,
    spxIconSite,
    spxIconSort,
    spxIconSquareArrowUpRightRound,
    spxIconSquareArrowUp,
    spxIconSquareLock02,
    spxIconStatusCanceled,
    spxIconStatusClosed,
    spxIconStatusComplete,
    spxIconStatusInProgress,
    spxIconStatusNew,
    spxIconStatusPending,
    spxIconStatusScheduled,
    spxIconStorefront,
    spxIconTick01,
    spxIconTick,
    spxIconUnavailable,
    spxIconUnlink04,
    spxIconUserCircle,
    spxIconVisibilityOff,
    spxIconVisibility,
    spxIconWarning,
    spxIconWifiActionRequired,
    spxIconWifiAttention,
    spxIconWifiNoConnection,
    spxIconWifiNoSignal,
    spxIconWifiNotAvailable,
    spxIconWifiOff,
    spxIconWifiSignalHigh,
    spxIconWifiSignalLow,
    spxIconWifiSignalMedium,
    spxIconWifiSignalNoData,
    spxIconWifi,
    spxIconWrenchFilled,
    spxIconWrenchOutlined,
    spxIconWrench
];
